
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import "firebase/firestore";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage'
import "firebase/storage";



const firebaseConfig = {
  apiKey: "AIzaSyBYg_HFthV-x3gh_B2A3Z-R7r6EGykaHVk",
  authDomain: "chuapukur-ict.firebaseapp.com",
  projectId: "chuapukur-ict",
  storageBucket: "chuapukur-ict.firebasestorage.app",
  messagingSenderId: "63456460747",
  appId: "1:63456460747:web:fd990be557ebf6e1cd004e",
  measurementId: "G-13SSPWG7ZD"

};
//init firebase app
const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const db = getFirestore(app);




export default app;